/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * TipMi Admin API
 * Admin console backend API consumed by tipmi-admin-web
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  CreateModerationHistoryRequestDTO,
  CreateReportNoteRequestDTO,
  GetModerationHistoryByContentParams,
  GetReportHistoryParams,
  SearchModerationItemsParams,
  SendFeedbackEmailRequestDTO,
  SendModerationNotificationRequestDTO,
  SuccessResponseDTOAdminReportDetailDTO,
  SuccessResponseDTOListAdminModerationHistoryResponseDTO,
  SuccessResponseDTOListHistoryResponseDTO,
  SuccessResponseDTOListMapStringString,
  SuccessResponseDTOModerationMetricsResponseDTO,
  SuccessResponseDTOPageResponseItemResponseDTO,
  SuccessResponseDTOVoid,
} from '.././model';

import { customInstance } from '../../http';

/**
 * @summary Send feedback email to reporter
 */
export const sendFeedbackEmail = (
  id: number,
  sendFeedbackEmailRequestDTO: SendFeedbackEmailRequestDTO,
  signal?: AbortSignal,
) => {
  return customInstance<SuccessResponseDTOVoid>({
    url: `/admin/api/moderation/report/${id}/send-feedback-email`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: sendFeedbackEmailRequestDTO,
    ...(signal ? { signal } : {}),
  });
};

export const getSendFeedbackEmailMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendFeedbackEmail>>,
    TError,
    { id: number; data: SendFeedbackEmailRequestDTO },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendFeedbackEmail>>,
  TError,
  { id: number; data: SendFeedbackEmailRequestDTO },
  TContext
> => {
  const mutationKey = ['sendFeedbackEmail'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendFeedbackEmail>>,
    { id: number; data: SendFeedbackEmailRequestDTO }
  > = (props) => {
    const { id, data } = props ?? {};

    return sendFeedbackEmail(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendFeedbackEmailMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendFeedbackEmail>>
>;
export type SendFeedbackEmailMutationBody = SendFeedbackEmailRequestDTO;
export type SendFeedbackEmailMutationError = unknown;

/**
 * @summary Send feedback email to reporter
 */
export const useSendFeedbackEmail = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof sendFeedbackEmail>>,
      TError,
      { id: number; data: SendFeedbackEmailRequestDTO },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof sendFeedbackEmail>>,
  TError,
  { id: number; data: SendFeedbackEmailRequestDTO },
  TContext
> => {
  const mutationOptions = getSendFeedbackEmailMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Save report note
 */
export const saveReportNote = (
  createReportNoteRequestDTO: CreateReportNoteRequestDTO,
  signal?: AbortSignal,
) => {
  return customInstance<SuccessResponseDTOVoid>({
    url: `/admin/api/moderation/report/save-note`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createReportNoteRequestDTO,
    ...(signal ? { signal } : {}),
  });
};

export const getSaveReportNoteMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveReportNote>>,
    TError,
    { data: CreateReportNoteRequestDTO },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof saveReportNote>>,
  TError,
  { data: CreateReportNoteRequestDTO },
  TContext
> => {
  const mutationKey = ['saveReportNote'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof saveReportNote>>,
    { data: CreateReportNoteRequestDTO }
  > = (props) => {
    const { data } = props ?? {};

    return saveReportNote(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SaveReportNoteMutationResult = NonNullable<Awaited<ReturnType<typeof saveReportNote>>>;
export type SaveReportNoteMutationBody = CreateReportNoteRequestDTO;
export type SaveReportNoteMutationError = unknown;

/**
 * @summary Save report note
 */
export const useSaveReportNote = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof saveReportNote>>,
      TError,
      { data: CreateReportNoteRequestDTO },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof saveReportNote>>,
  TError,
  { data: CreateReportNoteRequestDTO },
  TContext
> => {
  const mutationOptions = getSaveReportNoteMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Create moderation history
 */
export const createModerationHistory = (
  createModerationHistoryRequestDTO: CreateModerationHistoryRequestDTO,
  signal?: AbortSignal,
) => {
  return customInstance<SuccessResponseDTOVoid>({
    url: `/admin/api/moderation/report/history/create`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createModerationHistoryRequestDTO,
    ...(signal ? { signal } : {}),
  });
};

export const getCreateModerationHistoryMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createModerationHistory>>,
    TError,
    { data: CreateModerationHistoryRequestDTO },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createModerationHistory>>,
  TError,
  { data: CreateModerationHistoryRequestDTO },
  TContext
> => {
  const mutationKey = ['createModerationHistory'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createModerationHistory>>,
    { data: CreateModerationHistoryRequestDTO }
  > = (props) => {
    const { data } = props ?? {};

    return createModerationHistory(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateModerationHistoryMutationResult = NonNullable<
  Awaited<ReturnType<typeof createModerationHistory>>
>;
export type CreateModerationHistoryMutationBody = CreateModerationHistoryRequestDTO;
export type CreateModerationHistoryMutationError = unknown;

/**
 * @summary Create moderation history
 */
export const useCreateModerationHistory = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createModerationHistory>>,
      TError,
      { data: CreateModerationHistoryRequestDTO },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createModerationHistory>>,
  TError,
  { data: CreateModerationHistoryRequestDTO },
  TContext
> => {
  const mutationOptions = getCreateModerationHistoryMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Reopen report
 */
export const reopenReport = (id: number) => {
  return customInstance<SuccessResponseDTOVoid>({
    url: `/admin/api/moderation/report/${id}/reopen`,
    method: 'PATCH',
  });
};

export const getReopenReportMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reopenReport>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reopenReport>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['reopenReport'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof reopenReport>>, { id: number }> = (
    props,
  ) => {
    const { id } = props ?? {};

    return reopenReport(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReopenReportMutationResult = NonNullable<Awaited<ReturnType<typeof reopenReport>>>;

export type ReopenReportMutationError = unknown;

/**
 * @summary Reopen report
 */
export const useReopenReport = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof reopenReport>>,
      TError,
      { id: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof reopenReport>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getReopenReportMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Dismiss report
 */
export const dismissReport = (id: number) => {
  return customInstance<SuccessResponseDTOVoid>({
    url: `/admin/api/moderation/report/${id}/dismiss`,
    method: 'PATCH',
  });
};

export const getDismissReportMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dismissReport>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dismissReport>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['dismissReport'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof dismissReport>>, { id: number }> = (
    props,
  ) => {
    const { id } = props ?? {};

    return dismissReport(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DismissReportMutationResult = NonNullable<Awaited<ReturnType<typeof dismissReport>>>;

export type DismissReportMutationError = unknown;

/**
 * @summary Dismiss report
 */
export const useDismissReport = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof dismissReport>>,
      TError,
      { id: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof dismissReport>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDismissReportMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get reporting content JSON
 */
export const getReportingContent = (signal?: AbortSignal) => {
  return customInstance<string>({
    url: `/admin/api/moderation/reporting-content`,
    method: 'GET',
    ...(signal ? { signal } : {}),
  });
};

export const getGetReportingContentQueryKey = () => {
  return [`/admin/api/moderation/reporting-content`] as const;
};

export const getGetReportingContentQueryOptions = <
  TData = Awaited<ReturnType<typeof getReportingContent>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportingContent>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetReportingContentQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportingContent>>> = ({ signal }) =>
    getReportingContent(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getReportingContent>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetReportingContentQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReportingContent>>
>;
export type GetReportingContentQueryError = unknown;

export function useGetReportingContent<
  TData = Awaited<ReturnType<typeof getReportingContent>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReportingContent>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportingContent>>,
          TError,
          Awaited<ReturnType<typeof getReportingContent>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetReportingContent<
  TData = Awaited<ReturnType<typeof getReportingContent>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReportingContent>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportingContent>>,
          TError,
          Awaited<ReturnType<typeof getReportingContent>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetReportingContent<
  TData = Awaited<ReturnType<typeof getReportingContent>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReportingContent>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get reporting content JSON
 */

export function useGetReportingContent<
  TData = Awaited<ReturnType<typeof getReportingContent>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReportingContent>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetReportingContentQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get report by ID
 */
export const getReport = (id: number, signal?: AbortSignal) => {
  return customInstance<SuccessResponseDTOAdminReportDetailDTO>({
    url: `/admin/api/moderation/report/${id}`,
    method: 'GET',
    ...(signal ? { signal } : {}),
  });
};

export const getGetReportQueryKey = (id?: number) => {
  return [`/admin/api/moderation/report/${id}`] as const;
};

export const getGetReportQueryOptions = <
  TData = Awaited<ReturnType<typeof getReport>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReport>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetReportQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReport>>> = ({ signal }) =>
    getReport(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getReport>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetReportQueryResult = NonNullable<Awaited<ReturnType<typeof getReport>>>;
export type GetReportQueryError = unknown;

export function useGetReport<TData = Awaited<ReturnType<typeof getReport>>, TError = unknown>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReport>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReport>>,
          TError,
          Awaited<ReturnType<typeof getReport>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetReport<TData = Awaited<ReturnType<typeof getReport>>, TError = unknown>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReport>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReport>>,
          TError,
          Awaited<ReturnType<typeof getReport>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetReport<TData = Awaited<ReturnType<typeof getReport>>, TError = unknown>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReport>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get report by ID
 */

export function useGetReport<TData = Awaited<ReturnType<typeof getReport>>, TError = unknown>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReport>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetReportQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Delete report by ID
 */
export const deleteReport = (id: number) => {
  return customInstance<SuccessResponseDTOVoid>({
    url: `/admin/api/moderation/report/${id}`,
    method: 'DELETE',
  });
};

export const getDeleteReportMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteReport>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteReport>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['deleteReport'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteReport>>, { id: number }> = (
    props,
  ) => {
    const { id } = props ?? {};

    return deleteReport(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteReportMutationResult = NonNullable<Awaited<ReturnType<typeof deleteReport>>>;

export type DeleteReportMutationError = unknown;

/**
 * @summary Delete report by ID
 */
export const useDeleteReport = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteReport>>,
      TError,
      { id: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteReport>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteReportMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get moderation history by report ID
 */
export const getModerationHistory = (id: number, signal?: AbortSignal) => {
  return customInstance<SuccessResponseDTOListAdminModerationHistoryResponseDTO>({
    url: `/admin/api/moderation/report/${id}/history`,
    method: 'GET',
    ...(signal ? { signal } : {}),
  });
};

export const getGetModerationHistoryQueryKey = (id?: number) => {
  return [`/admin/api/moderation/report/${id}/history`] as const;
};

export const getGetModerationHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof getModerationHistory>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getModerationHistory>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetModerationHistoryQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getModerationHistory>>> = ({ signal }) =>
    getModerationHistory(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getModerationHistory>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetModerationHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getModerationHistory>>
>;
export type GetModerationHistoryQueryError = unknown;

export function useGetModerationHistory<
  TData = Awaited<ReturnType<typeof getModerationHistory>>,
  TError = unknown,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getModerationHistory>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getModerationHistory>>,
          TError,
          Awaited<ReturnType<typeof getModerationHistory>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetModerationHistory<
  TData = Awaited<ReturnType<typeof getModerationHistory>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getModerationHistory>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getModerationHistory>>,
          TError,
          Awaited<ReturnType<typeof getModerationHistory>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetModerationHistory<
  TData = Awaited<ReturnType<typeof getModerationHistory>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getModerationHistory>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get moderation history by report ID
 */

export function useGetModerationHistory<
  TData = Awaited<ReturnType<typeof getModerationHistory>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getModerationHistory>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetModerationHistoryQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get report history
 */
export const getReportHistory = (params: GetReportHistoryParams, signal?: AbortSignal) => {
  return customInstance<SuccessResponseDTOListHistoryResponseDTO>({
    url: `/admin/api/moderation/report/history`,
    method: 'GET',
    params,
    ...(signal ? { signal } : {}),
  });
};

export const getGetReportHistoryQueryKey = (params?: GetReportHistoryParams) => {
  return [`/admin/api/moderation/report/history`, ...(params ? [params] : [])] as const;
};

export const getGetReportHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof getReportHistory>>,
  TError = unknown,
>(
  params: GetReportHistoryParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportHistory>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetReportHistoryQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportHistory>>> = ({ signal }) =>
    getReportHistory(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getReportHistory>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetReportHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getReportHistory>>>;
export type GetReportHistoryQueryError = unknown;

export function useGetReportHistory<
  TData = Awaited<ReturnType<typeof getReportHistory>>,
  TError = unknown,
>(
  params: GetReportHistoryParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportHistory>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportHistory>>,
          TError,
          Awaited<ReturnType<typeof getReportHistory>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetReportHistory<
  TData = Awaited<ReturnType<typeof getReportHistory>>,
  TError = unknown,
>(
  params: GetReportHistoryParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportHistory>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportHistory>>,
          TError,
          Awaited<ReturnType<typeof getReportHistory>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetReportHistory<
  TData = Awaited<ReturnType<typeof getReportHistory>>,
  TError = unknown,
>(
  params: GetReportHistoryParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportHistory>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get report history
 */

export function useGetReportHistory<
  TData = Awaited<ReturnType<typeof getReportHistory>>,
  TError = unknown,
>(
  params: GetReportHistoryParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportHistory>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetReportHistoryQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get moderation history by content
 */
export const getModerationHistoryByContent = (
  contentId: number,
  params?: GetModerationHistoryByContentParams,
  signal?: AbortSignal,
) => {
  return customInstance<SuccessResponseDTOListAdminModerationHistoryResponseDTO>({
    url: `/admin/api/moderation/report/content/${contentId}/history`,
    method: 'GET',
    params,
    ...(signal ? { signal } : {}),
  });
};

export const getGetModerationHistoryByContentQueryKey = (
  contentId?: number,
  params?: GetModerationHistoryByContentParams,
) => {
  return [
    `/admin/api/moderation/report/content/${contentId}/history`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetModerationHistoryByContentQueryOptions = <
  TData = Awaited<ReturnType<typeof getModerationHistoryByContent>>,
  TError = unknown,
>(
  contentId: number,
  params?: GetModerationHistoryByContentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getModerationHistoryByContent>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetModerationHistoryByContentQueryKey(contentId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getModerationHistoryByContent>>> = ({
    signal,
  }) => getModerationHistoryByContent(contentId, params, signal);

  return { queryKey, queryFn, enabled: !!contentId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getModerationHistoryByContent>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetModerationHistoryByContentQueryResult = NonNullable<
  Awaited<ReturnType<typeof getModerationHistoryByContent>>
>;
export type GetModerationHistoryByContentQueryError = unknown;

export function useGetModerationHistoryByContent<
  TData = Awaited<ReturnType<typeof getModerationHistoryByContent>>,
  TError = unknown,
>(
  contentId: number,
  params: undefined | GetModerationHistoryByContentParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getModerationHistoryByContent>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getModerationHistoryByContent>>,
          TError,
          Awaited<ReturnType<typeof getModerationHistoryByContent>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetModerationHistoryByContent<
  TData = Awaited<ReturnType<typeof getModerationHistoryByContent>>,
  TError = unknown,
>(
  contentId: number,
  params?: GetModerationHistoryByContentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getModerationHistoryByContent>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getModerationHistoryByContent>>,
          TError,
          Awaited<ReturnType<typeof getModerationHistoryByContent>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetModerationHistoryByContent<
  TData = Awaited<ReturnType<typeof getModerationHistoryByContent>>,
  TError = unknown,
>(
  contentId: number,
  params?: GetModerationHistoryByContentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getModerationHistoryByContent>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get moderation history by content
 */

export function useGetModerationHistoryByContent<
  TData = Awaited<ReturnType<typeof getModerationHistoryByContent>>,
  TError = unknown,
>(
  contentId: number,
  params?: GetModerationHistoryByContentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getModerationHistoryByContent>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetModerationHistoryByContentQueryOptions(contentId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get report types
 */
export const getReportTypes = (signal?: AbortSignal) => {
  return customInstance<SuccessResponseDTOListMapStringString>({
    url: `/admin/api/moderation/report-types`,
    method: 'GET',
    ...(signal ? { signal } : {}),
  });
};

export const getGetReportTypesQueryKey = () => {
  return [`/admin/api/moderation/report-types`] as const;
};

export const getGetReportTypesQueryOptions = <
  TData = Awaited<ReturnType<typeof getReportTypes>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportTypes>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetReportTypesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportTypes>>> = ({ signal }) =>
    getReportTypes(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getReportTypes>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetReportTypesQueryResult = NonNullable<Awaited<ReturnType<typeof getReportTypes>>>;
export type GetReportTypesQueryError = unknown;

export function useGetReportTypes<
  TData = Awaited<ReturnType<typeof getReportTypes>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportTypes>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportTypes>>,
          TError,
          Awaited<ReturnType<typeof getReportTypes>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetReportTypes<
  TData = Awaited<ReturnType<typeof getReportTypes>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportTypes>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportTypes>>,
          TError,
          Awaited<ReturnType<typeof getReportTypes>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetReportTypes<
  TData = Awaited<ReturnType<typeof getReportTypes>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportTypes>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get report types
 */

export function useGetReportTypes<
  TData = Awaited<ReturnType<typeof getReportTypes>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportTypes>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetReportTypesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Search moderation items
 */
export const searchModerationItems = (
  params: SearchModerationItemsParams,
  signal?: AbortSignal,
) => {
  return customInstance<SuccessResponseDTOPageResponseItemResponseDTO>({
    url: `/admin/api/moderation/items`,
    method: 'GET',
    params,
    ...(signal ? { signal } : {}),
  });
};

export const getSearchModerationItemsQueryKey = (params?: SearchModerationItemsParams) => {
  return [`/admin/api/moderation/items`, ...(params ? [params] : [])] as const;
};

export const getSearchModerationItemsQueryOptions = <
  TData = Awaited<ReturnType<typeof searchModerationItems>>,
  TError = unknown,
>(
  params: SearchModerationItemsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchModerationItems>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSearchModerationItemsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof searchModerationItems>>> = ({ signal }) =>
    searchModerationItems(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof searchModerationItems>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type SearchModerationItemsQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchModerationItems>>
>;
export type SearchModerationItemsQueryError = unknown;

export function useSearchModerationItems<
  TData = Awaited<ReturnType<typeof searchModerationItems>>,
  TError = unknown,
>(
  params: SearchModerationItemsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchModerationItems>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchModerationItems>>,
          TError,
          Awaited<ReturnType<typeof searchModerationItems>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useSearchModerationItems<
  TData = Awaited<ReturnType<typeof searchModerationItems>>,
  TError = unknown,
>(
  params: SearchModerationItemsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchModerationItems>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchModerationItems>>,
          TError,
          Awaited<ReturnType<typeof searchModerationItems>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useSearchModerationItems<
  TData = Awaited<ReturnType<typeof searchModerationItems>>,
  TError = unknown,
>(
  params: SearchModerationItemsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchModerationItems>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Search moderation items
 */

export function useSearchModerationItems<
  TData = Awaited<ReturnType<typeof searchModerationItems>>,
  TError = unknown,
>(
  params: SearchModerationItemsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchModerationItems>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getSearchModerationItemsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Delete comment and its replies
 */
export const deleteComment = (id: number) => {
  return customInstance<SuccessResponseDTOVoid>({
    url: `/admin/api/moderation/comment/${id}`,
    method: 'DELETE',
  });
};

export const getDeleteCommentMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteComment>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteComment>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['deleteComment'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteComment>>, { id: number }> = (
    props,
  ) => {
    const { id } = props ?? {};

    return deleteComment(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteCommentMutationResult = NonNullable<Awaited<ReturnType<typeof deleteComment>>>;

export type DeleteCommentMutationError = unknown;

/**
 * @summary Delete comment and its replies
 */
export const useDeleteComment = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteComment>>,
      TError,
      { id: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteComment>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteCommentMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Moderation queue aggregate metrics
 */
export const getModerationMetrics = (signal?: AbortSignal) => {
  return customInstance<SuccessResponseDTOModerationMetricsResponseDTO>({
    url: `/admin/api/moderation/metrics`,
    method: 'GET',
    ...(signal ? { signal } : {}),
  });
};

export const getGetModerationMetricsQueryKey = () => {
  return [`/admin/api/moderation/metrics`] as const;
};

export const getGetModerationMetricsQueryOptions = <
  TData = Awaited<ReturnType<typeof getModerationMetrics>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getModerationMetrics>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetModerationMetricsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getModerationMetrics>>> = ({ signal }) =>
    getModerationMetrics(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getModerationMetrics>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetModerationMetricsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getModerationMetrics>>
>;
export type GetModerationMetricsQueryError = unknown;

export function useGetModerationMetrics<
  TData = Awaited<ReturnType<typeof getModerationMetrics>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getModerationMetrics>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getModerationMetrics>>,
          TError,
          Awaited<ReturnType<typeof getModerationMetrics>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetModerationMetrics<
  TData = Awaited<ReturnType<typeof getModerationMetrics>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getModerationMetrics>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getModerationMetrics>>,
          TError,
          Awaited<ReturnType<typeof getModerationMetrics>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetModerationMetrics<
  TData = Awaited<ReturnType<typeof getModerationMetrics>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getModerationMetrics>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Moderation queue aggregate metrics
 */

export function useGetModerationMetrics<
  TData = Awaited<ReturnType<typeof getModerationMetrics>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getModerationMetrics>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetModerationMetricsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Send in-app notification to a user from moderation
 */
export const sendModerationNotification = (
  sendModerationNotificationRequestDTO: SendModerationNotificationRequestDTO,
  signal?: AbortSignal,
) => {
  return customInstance<SuccessResponseDTOVoid>({
    url: `/admin/api/moderation/send-notification`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: sendModerationNotificationRequestDTO,
    ...(signal ? { signal } : {}),
  });
};

export const getSendModerationNotificationMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendModerationNotification>>,
    TError,
    { data: SendModerationNotificationRequestDTO },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendModerationNotification>>,
  TError,
  { data: SendModerationNotificationRequestDTO },
  TContext
> => {
  const mutationKey = ['sendModerationNotification'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendModerationNotification>>,
    { data: SendModerationNotificationRequestDTO }
  > = (props) => {
    const { data } = props ?? {};

    return sendModerationNotification(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendModerationNotificationMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendModerationNotification>>
>;
export type SendModerationNotificationMutationBody = SendModerationNotificationRequestDTO;
export type SendModerationNotificationMutationError = unknown;

/**
 * @summary Send in-app notification to a user from moderation
 */
export const useSendModerationNotification = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof sendModerationNotification>>,
      TError,
      { data: SendModerationNotificationRequestDTO },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof sendModerationNotification>>,
  TError,
  { data: SendModerationNotificationRequestDTO },
  TContext
> => {
  const mutationOptions = getSendModerationNotificationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Hard-delete the reported message
 */
export const deleteReportedMessage = (id: number) => {
  return customInstance<SuccessResponseDTOVoid>({
    url: `/admin/api/moderation/report/${id}/message`,
    method: 'DELETE',
  });
};

export const getDeleteReportedMessageMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteReportedMessage>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteReportedMessage>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['deleteReportedMessage'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteReportedMessage>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteReportedMessage(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteReportedMessageMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteReportedMessage>>
>;

export type DeleteReportedMessageMutationError = unknown;

/**
 * @summary Hard-delete the reported message
 */
export const useDeleteReportedMessage = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteReportedMessage>>,
      TError,
      { id: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteReportedMessage>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteReportedMessageMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
